import Head from "next/head"
import Link from "next/link"
import { BlitzPage, Routes } from "@blitzjs/next"
import { useRouter } from "next/router"
import { useQuery, useMutation } from "@blitzjs/rpc"
import Layout from "app/core/layouts/Layout"
import Suspense from "app/core/components/Suspense"
import getUsers from "app/users/queries/getUsers"
import deleteUser from "app/users/mutations/deleteUser"
import Container from "@mui/material/Container"
import Paper from "@mui/material/Paper"
import Typography from "@mui/material/Typography"
import TableContainer from "@mui/material/TableContainer"
import Table from "@mui/material/Table"
import TableBody from "@mui/material/TableBody"
import TableCell from "@mui/material/TableCell"
import TableHead from "@mui/material/TableHead"
import TableRow from "@mui/material/TableRow"
import Stack from "@mui/material/Stack"
import Avatar from "@mui/material/Avatar"
import Box from "@mui/material/Box"
import Button from "@mui/material/Button"
import IconButton from "@mui/material/IconButton"
import AddIcon from "@mui/icons-material/Add"
import DeleteIcon from "@mui/icons-material/Delete"

export const UsersList = () => {
  const router = useRouter()
  const page = Number(router.query.page) || 0
  const [users, { refetch }] = useQuery(getUsers, {
    orderBy: { name: "asc" },
  })
  const [deleteUserMutation] = useMutation(deleteUser)

  return (
    <TableContainer component={Paper}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell></TableCell>
            <TableCell>Name</TableCell>
            <TableCell>Email</TableCell>
            <TableCell></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {users.map((user) => (
            <TableRow key={user.id} hover={true}>
              <TableCell sx={{ width: "1px", pr: 0 }}>
                <Avatar alt={user.name || undefined} src={user.avatarUrl || undefined} />
              </TableCell>
              <TableCell>{user.name}</TableCell>
              <TableCell>{user.email}</TableCell>
              <TableCell sx={{ py: 0 }}>
                <Stack direction="row" justifyContent="flex-end">
                  <IconButton
                    onClick={async () => {
                      if (window.confirm("This will be deleted")) {
                        await deleteUserMutation({ id: user.id })
                        await refetch()
                      }
                    }}
                  >
                    <DeleteIcon />
                  </IconButton>
                </Stack>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  )
}

const UsersPage: BlitzPage = () => {
  return (
    <>
      <Head>
        <title>Users</title>
      </Head>

      <Container maxWidth={false}>
        <Box sx={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
          <Typography sx={{ my: 4, flexGrow: 1 }} variant="h4" component="h2">
            Admin Users
          </Typography>
          <Box>
            <Link href={Routes.NewUserPage()} legacyBehavior>
              <Button variant="contained" startIcon={<AddIcon />}>
                Create
              </Button>
            </Link>
          </Box>
        </Box>
        <Suspense>
          <UsersList />
        </Suspense>
      </Container>
    </>
  )
}

UsersPage.authenticate = true
UsersPage.getLayout = (page) => <Layout>{page}</Layout>

export default UsersPage
